import { authenticatedFetch } from '../../../api/request';

export default async function getAllSchedules(doctorId, setErrorMessage) {
    const onError = () => setErrorMessage('No se puede obtener los horarios de atención.');
    return await authenticatedFetch(`/doctor-profile-management/all-schedules/${doctorId}`, onError);
}
